module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Mary-Shelley.e99252f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Mary-Shelley.jpg
// module id = ySOe
// module chunks = 0